/**
 * The currencies this system can actually convert.
 *
 * <p>Exactly the ECB daily reference set plus USD, because those are the rates `FxRateService`
 * holds. Offering anything else lets a figure be recorded that nothing can convert: an
 * unconvertible debt drops out of net worth, and unconvertible living costs drop out of the
 * audit's buffer coverage. Both errors run the same way - they make someone look better off than
 * they are - which is the one direction this application refuses to be wrong in quietly.
 *
 * <p>Shared rather than declared per form. Two lists would drift, and the half that fell behind
 * would be offering currencies the server cannot price.
 */
export const CURRENCIES = [
  'USD', 'EUR', 'GBP', 'CHF', 'PLN', 'CZK', 'SEK', 'NOK', 'DKK', 'HUF', 'RON', 'ISK', 'TRY',
  'CAD', 'AUD', 'NZD', 'JPY', 'CNY', 'HKD', 'SGD', 'KRW', 'INR', 'IDR', 'MYR', 'PHP', 'THB',
  'ILS', 'ZAR', 'BRL', 'MXN',
] as const

export type ConvertibleCurrency = (typeof CURRENCIES)[number]
